var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-overview" },
    [
      _c("vs-row", [
        _c(
          "div",
          {
            staticClass: "overview-posts",
            attrs: { id: "loadableContent-list-posts" },
          },
          [
            _c(
              "div",
              { staticClass: "table-title" },
              [
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text: _vm.$t("dash.overview.title.posts.tooltip"),
                      position: "right",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.overview.title.posts"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm.getLastPostsLoading
              ? _c("component-loader", {
                  attrs: { progress: 90, unlimitedProgress: true },
                })
              : _vm._e(),
            _vm.postsData && !_vm.postsData.length
              ? _c("div", { staticClass: "list-wrapper" }, [
                  _c("p", { staticClass: "txt" }, [
                    _vm._v(_vm._s(_vm.$t("dash.overview.empty"))),
                  ]),
                ])
              : _vm._e(),
            _vm.postsData && !!_vm.postsData.length
              ? _c("component-table", {
                  attrs: {
                    gridData: _vm.postsData,
                    columns: _vm.postsColumn,
                    name: "overview",
                  },
                })
              : _vm._e(),
            _vm.postsData && _vm.postsData.length && _vm.getUserPlan
              ? _c(
                  "vs-button",
                  {
                    staticClass: "posts-btn btn-large",
                    attrs: {
                      color: "#2F1937",
                      "vs-type": "filled",
                      size: "large",
                      type: "submit",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.go("posts")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("dash.button.all")))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      ["Admin", "Editor"].includes(_vm.getUserRole)
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "overview-column" }, [
              _c("div", { staticClass: "table-title" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.overview.title.mine")))]),
              ]),
              _c(
                "div",
                { staticClass: "list-pages" },
                [
                  _c("component-list", {
                    attrs: {
                      gridData: _vm.pagesData,
                      columns: _vm.pagesColumn,
                      interaction: true,
                      name: "pages",
                      disable: (x) => !_vm.checkLock(x.network),
                    },
                    on: { "edit-pages": _vm.go, "post-clicked": _vm.goToPost },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "overview-column" }, [
              _c("div", { staticClass: "table-title" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.overview.title.active")))]),
              ]),
              _c(
                "div",
                { staticClass: "list-news" },
                [
                  _c("component-list", {
                    attrs: {
                      gridData: _vm.botsData,
                      columns: _vm.botsColumn,
                      interaction: false,
                      disable: (x) => !_vm.checkLock(x.page.network),
                      name: "posts",
                    },
                    on: { "edit-posts": _vm.goToBot },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }